import { BaseModel } from '../../_base/crud';

export class CompanyModel extends BaseModel {
  id: number;
  company_uuid: string;
  name: string;
  admin: string;
  adminID: number;
  adminEmail: string;
  limitNumberOffices: number;
  limitNumberUsers: number;
  numberOffices: number;
  numberUsers: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  measurementSystem: string;
  logoSquareBase64: string;
  additionalLogoBase64: string;
  logoBase64: string;
  logoUrl: string;
  additionalLogoUrl: string;
  logoSquareUrl: string;
  primaryColor1: string;
  primaryColor2: string;
  primaryColor3: string;
  secondaryColor1: string;
  secondaryColor2: string;
  secondaryColor3: string;
  termsUrl: string;
  privacyPolicyUrl: string;
  contactUsUrl: string;
  tutorialsUrl: string;
  serviceSurveyUrl: string;
  branding: any;
  primaryContacts?: PrimaryContacts;

  clear() {
    this.id = null;
    this.company_uuid = '';
    this.name = '';
    this.adminID = 0;
    this.adminEmail = '';
    this.limitNumberOffices = 0;
    this.limitNumberUsers = 0;
    this.numberOffices = 0;
    this.numberUsers = 0;
    this.createdAt = new Date();
    this.updatedAt = new Date();
    this.isActive = false;
    this.measurementSystem = 'm';
  }
}

export class PrimaryContacts {
  technicalLead: Contact | null = null;
  operationsLead: Contact | null = null;
  pharmacyLead: Contact | null = null;
}

export class Contact {
  name: string | null = null;
  email: string | null = null;
  phone: string | null = null;
}
